import { Ayah } from '@app-types/KuranTypes'
import { useUserData } from '@contexts/UserDataContext'
import useFontSizes from '@hooks/useFontSizes'
import classNames from 'classnames'
import { getSurahAnchorId } from 'helpers/surahAnchor'
import AyahComponent from '../KelimeMealliPage/AyahComponent'

type MealliKuranPageProps = {
  ayahs: Ayah[]
}

export default function MealliKuranPage({ ayahs }: MealliKuranPageProps) {
  const { userData } = useUserData()
  const { kuranMealFontSize } = useFontSizes()
  const hideMeal = userData.kuranMealType === 'hide'
  const hideTooltip = userData.kuranTooltip === 'hide'

  if (!ayahs?.length) return null

  return (
    <div className="max-w-3xl mx-auto">
      {ayahs.map((ayah) => (
        <div key={ayah.id} className="mb-2">
          {/* Show Besmele and Surah Info if it's the first ayah */}
          {ayah.zero && (
            <>
              <div
                id={getSurahAnchorId(ayah.surah.id)}
                className="scroll-mt-32 px-4 py-2 my-2 text-lg tracking-wider rounded-full bg-slate-200 dark:bg-slate-700"
              >
                {ayah.surah.name} Suresi | {ayah.surah.verse_count} Ayet{' '}
              </div>
              <div
                className={classNames(
                  'text-4xl text-center mb-4',
                  userData.arabicFontFamily,
                )}
                style={{ direction: 'rtl' }}
              >
                {ayah.zero.verse}
              </div>
              <div className="text-xl italic mb-8 text-center">
                Rahman ve Rahim olan Allah'ın adıyla
              </div>
            </>
          )}

          {/* Arabic Text with Word-by-Word Translation */}
          <div
            className={classNames(
              'flex flex-wrap text-4xl mb-4',
              userData.arabicFontFamily,
              {
                'justify-center': userData.arabicFontAlignment === 'middle',
                'justify-start': userData.arabicFontAlignment === 'right',
              },
            )}
            style={{ direction: 'rtl' }}
          >
            {ayah.words
              .filter((word) => word.type === 'ayah')
              .map((word, wordIndex) => (
                <AyahComponent
                  key={wordIndex}
                  i={wordIndex}
                  word={word}
                  ayahNo={ayah.verse_number}
                  hideMeal={hideMeal}
                  hideTooltip={hideTooltip}
                />
              ))}
          </div>

          {/* Full Ayah Translation */}
          <div
            className="mb-2 text-left leading-relaxed"
            style={{ fontSize: `${kuranMealFontSize}px` }}
          >
            {userData.kuranMealSource === 'meal_diyanet'
              ? ayah.meal_diyanet
              : ayah.muhtasar_tefsir}
          </div>

          {/* Ayah Info */}
          <div className="text-center text-sm text-gray-600 dark:text-gray-400">
            {ayah.surah.name} Suresi, {ayah.verse_number}. Ayet
          </div>
          <hr className="my-4" />
        </div>
      ))}
    </div>
  )
}
